// extracted by mini-css-extract-plugin
module.exports = {"DataList":"DataList_DataList__1kZEU","list":"DataList_list__gvnX8"};